import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class GuiFlowManagerService {

  constructor(private _snackBar: MatSnackBar) { }


    // ---------------------------
  // SNACKBAR AND ALERTS

  openSimpleSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
    });
  }
}
